// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"1aa54e37","68":"293c4b26","117":"5599c878","273":"649a30d6","613":"82f4ded2"}[chunkId] + ".chunk.js";
};